import React from "react";
import Card from "./Card";

// Premium KPI / metric card. Tabular numerics, optional delta + sparkline.
//
// Usage:
//   <Stat label="Total tasks" value={142} delta={+12} hint="vs last week" tone="success" />

// Icon-chip tones, from the paired --tone-* tokens so they invert with the theme.
const TONES = {
  neutral: { color: "var(--text-secondary)",  bg: "var(--bg-subtle)" },
  success: { color: "var(--tone-success-fg)", bg: "var(--tone-success-bg)" },
  warning: { color: "var(--tone-warning-fg)", bg: "var(--tone-warning-bg)" },
  danger:  { color: "var(--tone-danger-fg)",  bg: "var(--tone-danger-bg)" },
  brand:   { color: "var(--accent-text)",     bg: "var(--accent-soft)" },
};

export default function Stat({
  label,
  value,
  delta,
  hint,
  tone = "neutral",
  icon: Icon,
  loading = false,
}) {
  const t = TONES[tone] || TONES.neutral;
  if (loading) {
    return (
      <Card padding="md">
        <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", color: "var(--text-tertiary)", fontWeight: 600 }}>{label}</div>
        <div className="ds-skeleton" style={{ height: 32, marginTop: 8, width: "60%" }} />
        <div className="ds-skeleton" style={{ height: 12, marginTop: 8, width: "40%" }} />
      </Card>
    );
  }
  return (
    <Card padding="md">
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 6 }}>
        <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", color: "var(--text-tertiary)", fontWeight: 600 }}>
          {label}
        </div>
        {Icon && (
          <div style={{ width: 28, height: 28, borderRadius: 8, background: t.bg, color: t.color, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon size={14} />
          </div>
        )}
      </div>
      <div className="tabular" style={{ fontSize: 28, fontWeight: 600, color: "var(--text-primary)", letterSpacing: "-0.02em", lineHeight: 1.1 }}>
        {value}
      </div>
      {(delta !== undefined || hint) && (
        <div style={{ marginTop: 8, fontSize: 12, color: "var(--text-tertiary)", display: "flex", alignItems: "center", gap: 6 }}>
          {delta !== undefined && (
            <span className="tabular" style={{
              color: delta >= 0 ? "var(--accent-text)" : "var(--tone-danger-fg)",
              fontWeight: 500,
            }}>
              {delta >= 0 ? "↗" : "↘"} {delta > 0 ? "+" : ""}{delta}
            </span>
          )}
          {hint && <span>{hint}</span>}
        </div>
      )}
    </Card>
  );
}
